import styled from 'styled-components';
import colors from 'theme/colors';

export const BreedersColumnActiveStatusStyles = styled.section`
  .status-label-active {
    color: ${colors.success};
  }

  .status-label-inactive {
    color: ${colors.blackAlpha(0.55)};
  }
`;
